import ApiHandler from "./ApiHandler";

const City = {
  findAll: async (query) => await ApiHandler.i.auth().get(`/city?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/city/find?${query.toString()}`),
  getOne: async (cityId) => await ApiHandler.i.auth().get(`/city/${cityId}`),
};

export default City;